import { global as global_permissions } from "@/app/components/Auth/permissions";

const globalPermissionKeys = new Set(
	global_permissions.map((item) => item.key)
);

export const insertOrDeletePermission = (
	userId,
	organisationId,
	permissions,
	items,
	callAPI
) => {
	const operations = [];
	for (const perm of permissions.filter((p) => p.checked)) {
		const effectiveOrganisationId = globalPermissionKeys.has(perm.key)
			? null
			: organisationId;
		if (!items.find((x) => x.type === perm.key)) {
			operations.push(
				callAPI("permissions", {
					method: "POST",
					payload: {
						user_id: userId,
						organisation_id: effectiveOrganisationId
							? effectiveOrganisationId
							: null,
						type: perm.key,
					},
					one: true,
				})
			);
		}
	}

	for (const perm of permissions.filter((p) => !p.checked)) {
		const effectiveOrganisationId = globalPermissionKeys.has(perm.key)
			? null
			: organisationId;
		if (items.find((x) => x.type === perm.key)) {
			operations.push(
				callAPI("permissions", {
					method: "DELETE",
					query: {
						user_id: `eq.${userId}`,
						organisation_id: effectiveOrganisationId
							? `eq.${effectiveOrganisationId}`
							: "is.null",
						type: `eq.${perm.key}`,
					},
				})
			);
		}
	}
	return operations;
};
